import { useMemo } from 'react';
import { usePurchaseRequestBrandSelectorListQuery } from 'api';

export const usePurchaseBrandMapping = (id: string): Record<string, any> => {
  const { data: purchaseRequestBrand = [] } = usePurchaseRequestBrandSelectorListQuery({ dealId: id });

  const purchaseRequestBrandMapping: Record<string, { name: string; id: string }> = useMemo(() => {
    const mapping: Record<string, { name: string; id: string }> = {};
    purchaseRequestBrand.forEach((i: { name: string; id: string }) => {
      mapping[i.id] = i;
    });
    return mapping;
  }, [purchaseRequestBrand]);

  return {
    purchaseRequestBrandMapping,
  };
};
